import { api } from "api/config";
import { user as readUser, setUser } from "localStorage";

// A staff admin's Role.pages (and permission[]) is only snapshotted into
// localStorage at login (backend/controllers/login.js does a live Role read
// there) — editing a Role afterward via the Users & Roles UI never pushes to
// already-logged-in sessions, and not even a plain browser refresh re-fetches
// it (App.js boots straight from the cached localStorage snapshot). This
// re-reads the live profile from the server and writes it back, which fires
// the "user-profile-updated" event (see localStorage/index.js `setUser`) that
// every permission-check consumer listens for via useUserRefreshTick().
//
// Module-level throttle + de-dupe (not per-caller) so rapid navigation across
// several pages — each of which may trigger this independently — doesn't fire
// a request per page.
let lastFetchAt = 0;
let inFlight = null;
const THROTTLE_MS = 5000;

export async function refreshUserProfile() {
  const now = Date.now();
  if (inFlight) return inFlight;
  if (now - lastFetchAt < THROTTLE_MS) return readUser();
  lastFetchAt = now;
  inFlight = api()
    .get("/user/me/profile")
    .then((res) => {
      if (res.data?.success && res.data.data) {
        setUser(res.data.data);
        return res.data.data;
      }
      return readUser();
    })
    .catch(() => readUser())
    .finally(() => {
      inFlight = null;
    });
  return inFlight;
}
